export const AssetStatuses = Object.freeze({
  AVAILABLE: "AVAILABLE",
  UNAVAILABLE: "UNAVAILABLE",
  NOT_AVAILABLE: "NOT_AVAILABLE",
});
